//TODO: Change this MUI to pure css
import { useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router'
import GeneratedAvatar from 'components/Common/GeneratedAvatar'

import { getAccountType } from 'utils'
import { useOnClickOutside } from 'hooks'
import routes from '../../../../routes'
import { Typography, Box, Link } from '@mui/material'
import I18n from 'i18next';


const sx = {
  dropdownBtn: {
    cursor: 'pointer',
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    right: '15px',
    zIndex: 9999,
    width: '350px',
    backgroundColor: '#fff',
    borderRadius: '5px',
    boxShadow:
      'rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgb(0, 0, 0, 0.12) 0px 1px 5px 0px',
  },
  dropdownHeader: {
    display: 'flex',
  },
  userStatus: {
    fontSize: '12px',
    color: 'var(--primary)',
  },
  navLink: {
    display: 'block',
    padding: '8px 13px',
    color: 'rgb(0,112,196)',
    cursor: 'pointer',
  },
  listGroup: {
    borderTop: '1px solid rgb(220,230,233)',
    borderRadius: '0',
    fontSize: '16px',
  },
  userName: {
    cursor: 'pointer',
    fontFamily: 'poppins',
    color: '#25245f',
  }
}

const UserDropdown = ({ user, onLogout }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef()
  useOnClickOutside(ref, () => setOpen(false))
  const navigate = useNavigate()

  const toggle = () => setOpen(!open)

  const onClickMyAccount = () => {
    navigate(routes.myAccount)
  }

  if (!user) {
    return <></>
  }
  const fullName = `${user.firstName || ''} ${user.lastName || ''}`
  return (
    <div className={`dropdown-container`} ref={ref}>
      <Box sx={sx.dropdownBtn} className={`dropdown-btn btn`} onClick={toggle} style={{ color: '#25245f' }}>
        <div className="d-flex align-items-center">
          <Typography variant='body1M' style={{ marginRight: '5px', fontFamily: 'poppins', fontWeight: 500, fontSize: '16px', lineHeight: '24px' }}>
            {fullName.length > 20 ? fullName.slice(0, 20) + '...' : (user.firstName) + ' ' + (user.lastName)}
          </Typography>
          <span>
            <FontAwesomeIcon icon={faCaretDown} style={{ marginRight: '18px' }} />
          </span>
          <span className="ms-2 d-inline-block">
            {user.avatarFileId ? (
              <GeneratedAvatar
                style={{ marginRight: '14px' }}
                width={40}
                height={40}
                src={`${process.env['REACT_APP_BACKEND_BASE_AUTH_URL']}/static/images/users/${user.avatarFileId}`}
                alt={`${user.firstName} ${user.lastName}`}
                text={user.firstName}
              />
            ) : (
              <GeneratedAvatar width={40} height={40} style={{ marginRight: '14px' }} text={user.firstName} />
            )}
          </span>
        </div>
      </Box>

      {open && (
        <Box sx={sx.dropdownList} className={`dropdown-list px-4 py-5`}>
          <Box component="header" sx={sx.dropdownHeader} className={`pb-4`}>
            <div className="user-avatar me-3">
              {user.avatarFileId ? (
                <GeneratedAvatar
                  width={40}
                  height={40}
                  src={`${process.env['REACT_APP_BACKEND_BASE_AUTH_URL']}/static/images/users/${user.avatarFileId}`}
                  alt={`${user.firstName} ${user.lastName}`}
                />
              ) : (
                <GeneratedAvatar text={user.firstName} />
              )}
            </div>
            <div className="user-info">
              <Box sx={sx.userName}
                className={`text-decoration-none fs-4 fw-bold`}
                onClick={onClickMyAccount}
              >
                {`${(user.firstName)} ${(user.lastName)}`}
              </Box>
              <Box component="p" sx={sx.userStatus} className={`mb-0`}>
                {user.created_date ? (
                  <span>{`Member Since ${user.created_date.getFullYear()} | ${getAccountType(user)}`}</span>
                ) : (
                  <span>{`Member Since 2022 | ${getAccountType(user)}`}</span>
                )}
              </Box>
            </div>
          </Box>
          <div className={`dropdown-list-body`}>
            <Box sx={sx.listGroup} className={`list-group py-4`}>
              <Box sx={sx.navLink} className={`fw-bold text-decoration-none`} onClick={onClickMyAccount}>
                {I18n.t('header.myAccount')}
              </Box>
              <Box sx={sx.navLink} c className={`d-inline-block text-left`} onClick={onLogout}>
                {I18n.t('header.signOut')}
              </Box>
            </Box>
            <Box sx={sx.listGroup} className={`list-group pt-4`}>
              <Link
                sx={sx.navLink}
                href="https://markaaz.com/terms-and-conditions/?_gl=1*1fp54r0*_ga*Mzg4MjUwNTg0LjE2NDczNjcwNzk.*_ga_ERS8LY82HR*MTY0ODIyNzAzMS45LjEuMTY0ODIyNzA2MC4zMQ.."
                target="_blank"
                rel="noreferrer"
                className={`text-decoration-none`}
              >
                {I18n.t('common.termsAndConditions')}
              </Link>
              <Link
                sx={sx.navLink}
                href="https://markaaz.com/privacy/"
                target="_blank"
                rel="noreferrer"
                className={`text-decoration-none`}
              >
                {I18n.t('common.privacyPolicy')}
              </Link >
            </Box>
          </div>
        </Box>
      )}
    </div>
  )
}

export default UserDropdown